import { render, staticRenderFns } from "./shipments-search.vue?vue&type=template&id=489f5d16&"
import script from "./shipments-search.vue?vue&type=script&lang=js&"
export * from "./shipments-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports